
import { useState, useEffect } from 'react'
import Swiper from 'swiper'
import React from 'react'

export default function Smooth(props) {
  const [ifon, setIfon] = useState({
    smooth: null
  })

  useEffect(() => {
    const example = new Swiper('.Smooth', {
      loop: true, // 循环模式选项
      autoplay: true,
      speed: props.playbackSpeed
    })

    setIfon({
      ...ifon,
      smooth: example
    })

    return () => {
      example.destroy && example.destroy()
    }
  }, [])

  useEffect(() => {
    ifon.smooth && (ifon.smooth.params.speed = props.playbackSpeed)
  }, [props.playbackSpeed])

  return (<div className='Smooth'>
    <div class='swiper-wrapper'>
      {props.ifon.image_id_list.map((item) => {
        return <div class='swiper-slide' key={item.id}>
          <img className='slide_img' src={item.src}></img>
        </div>
      })}

    </div>
  </div>)
}
console.log(React)
